import { Component, Input } from '@angular/core';

import { orcamento } from '../../config-pedido-tipo-venda-indicador';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-badge-orcamento',
    templateUrl: './config-pedido-tipo-venda-badge-orcamento.component.html',
    styleUrls: ['./config-pedido-tipo-venda-badge-orcamento.component.less']
})
export class ConfigPedidoTipoVendaBadgeOrcamentoComponent {
    tipo = orcamento;

    /** Se o badge deve exibir o tipo de forma abreviada */
    @Input() isAbreviacao = false;
}
